import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { InctvClaimLineList } from '@/sc/entities/inctvClaimLine/InctvClaimLineList';

export const InctvClaimDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'distClaimLine', label: 'Lines', content: <InctvClaimLineList inctvClaimObj={entityObj} /> },
  ];


  return (
    <EntityDetail tabSpecs={tabSpecs}  />
  )
}